import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-20 bg-primary text-white relative overflow-hidden" data-id="element-120">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full transform translate-x-1/2 -translate-y-1/2" data-id="element-121"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-black opacity-5 rounded-full transform -translate-x-1/2 translate-y-1/2" data-id="element-122"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-123">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 bg-white rounded-full mb-4 md:mb-8 shadow-xl" data-id="element-124">
          <ShieldCheck className="w-7 h-7 md:w-10 md:h-10 text-primary" data-id="element-125" />
        </div>

        <h2 className="text-2xl md:text-5xl font-bold font-serif mb-4 md:mb-8 leading-tight" data-id="element-126">
          ✨ GARANTÍA GIMNASIA RÍTMICA INFANTIL RESUELTA — 7 DÍAS ✨
        </h2>

        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl md:rounded-3xl p-5 md:p-12 mb-4 md:mb-8" data-id="element-127">
          <p className="text-base md:text-2xl font-medium leading-relaxed mb-3 md:mb-6" data-id="element-128">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés. Si en 7 días no es lo que esperabas:{' '}
            <strong className="text-white font-bold bg-black/20 px-2 py-0.5 md:py-1 rounded" data-id="element-129">
              Te devolvemos el 100%.
            </strong>{' '}
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="text-sm md:text-lg text-primary-light" data-id="element-130">
            La confianza que tenemos en Gimnasia Rítmica Infantil Resuelta™ nos
            permite hacer esa promesa sin dudar. Más de 300 instructoras ya lo
            saben.
          </p>
        </div>

        <div className="inline-block bg-white text-primary font-bold px-4 py-2 md:px-6 md:py-3 rounded-full shadow-lg uppercase tracking-wider text-xs md:text-sm" data-id="element-131">
          TASA DE DEVOLUCIONES MENOR AL 1%
        </div>
      </div>
    </section>;
}